import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import {ValidatedIcon} from '../../../../components/Controls/ValidateControl';
import {StickyHeader} from '../../../../components/Table/TableStyles';
import {EditedParticipation} from '../../../Partner/EditedPartner';
import {Filter, ProposalFilterValue} from '../../ParticipationFunctions/Filtering';
import {offsetOneRow, offsetTwoRows, centeredContainerStyle, StateStyledCell} from '../../Styles/ParticipationTableStyles';

const FilterContainer = styled.span`
    display: inline-block;
    height: 18px;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
`;

function ProposalIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path color="rgb(130, 240, 130)" d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
            <path color="rgb(60, 220, 60)" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z" />
        </svg>
    );
}

function NotProposalIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path color="rgb(255, 147, 69)" d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
        </svg>
    );
}

function UnsetIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path color="rgb(200, 200, 200)" d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
            <path color="rgb(200, 200, 200)" d="M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0z" />
        </svg>
    );
}

export function ProposalFilter({filter, updateFilter}: {filter: Filter; updateFilter: (filter: Filter) => void}) {
    const value = filter?.Proposal ?? ProposalFilterValue.Unset;

    function message() {
        switch (value) {
            case ProposalFilterValue.Unset: return 'Showing proposals and non-proposals';
            case ProposalFilterValue.Proposal: return 'Showing proposals only';
            case ProposalFilterValue.NotProposal: return 'Showing non-proposals only';
        }
    }

    function icon() {
        switch (value) {
            case ProposalFilterValue.Unset: return <UnsetIcon />;
            case ProposalFilterValue.Proposal: return <ProposalIcon />;
            case ProposalFilterValue.NotProposal: return <NotProposalIcon />;
        }
    }

    function nextValue() {
        switch (value) {
            case ProposalFilterValue.Unset: return ProposalFilterValue.Proposal;
            case ProposalFilterValue.Proposal: return ProposalFilterValue.NotProposal;
            case ProposalFilterValue.NotProposal: return ProposalFilterValue.Unset;
        }
    }

    return (
        <StickyHeader style={{...offsetTwoRows, ...centeredContainerStyle}}>
            <Tippy content={message()}>
                <FilterContainer onClick={() => updateFilter({...filter, Proposal: nextValue()})}>
                    {icon()}
                </FilterContainer>
            </Tippy>
        </StickyHeader>
    );
}

export function ProposalHeader() {
    return (
        <StickyHeader style={{...offsetOneRow, width: '50px', minWidth: '50px', maxWidth: '50px'}}>
            <Tippy content="Shows which projects are proposals">
                <span>Prop</span>
            </Tippy>
        </StickyHeader>
    );
}

export function ProposalContent({ppn}: {ppn: EditedParticipation}) {
    return (
        <StateStyledCell editStatus={ppn.EditStatus}>
            {ppn.PlantingProject?.Proposal && <ValidatedIcon />}
        </StateStyledCell>
    );
}
